<template>
  <div class="moderator-marketing-mailings-option">
    <div class="moderator-marketing-mailings-option__head">
      <h3 class="moderator-marketing-mailings-option__title">
        {{ $tModeratorMarketing('option_' + optionKey) }}
      </h3>
      <p v-if="optionType === 'many'"
         class="moderator-marketing-mailings-option__title-note">
        {{ $tModeratorMarketing('(You can select many)') }}
      </p>
    </div>

    <div class="moderator-marketing-mailings-option__main">
      <div v-if="optionType === 'many'"
           class="moderator-marketing-mailings-option__list">
        <div class="moderator-marketing-mailings-option__checkbox-wrap">
          <BaseCheckbox v-for="(variant) in option"
                        :key="variant.id"
                        :label="variant.label"
                        :checked="isCheckboxChecked(variant)"
                        @input="onCheckboxInput($event, variant)"
                        class="moderator-marketing-mailings-option__checkbox"/>
        </div>

      </div>


      <BaseRadioList v-else-if="optionType === 'one'"
                     :options="option"
                     :value="value"
                     textKey="label"
                     @input="$emit('input', $event)"
                     class="moderator-marketing-mailings-option__list">
        <template v-slot:mark>
          <BaseSvg name="ico-check"/>
        </template>
      </BaseRadioList>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AMMarketingMailingsOption',
    props: {
      value: [Number, Array, Object],
      option: Array,
      optionKey: String,
      optionType: String,
    },
    data() {
      return {}
    },
    methods: {
      isCheckboxChecked(variant) {
        const currentValue = this.value

        return Array.isArray(currentValue) && currentValue.some(v => v.key === variant.key)
      },
      onCheckboxInput(add, variant) {
        let currentValue = this.value

        if (add) {
          if (!Array.isArray(currentValue)) {
            currentValue = []
          }

          currentValue.push(variant)
        } else {
          if (!Array.isArray(currentValue)) return

          const index = currentValue.findIndex(v => v.key === variant.key)
          if (index < 0) return

          this.$delete(currentValue, index)

          if (!currentValue.length) {
            currentValue = null
          }
        }

        this.$emit('input', currentValue)
      }
    }
  }
</script>

<style lang="less">

</style>
